import React from 'react';
import { FastField as FormikField } from 'formik';
import { Option as IOption } from '../../gds-api-client';
import { Select, Option } from '@xo-union/tk-component-fields';
import styles from './styles.scss';

type DropdownOptions = IOption[] | null;

interface AnswerDropdownProps {
  options: DropdownOptions;
  name: string;
  placeholder: string;
}

export const AnswerDropdown: React.FC<AnswerDropdownProps> = ({ name, options, placeholder }) => {
  return (
    <div className={styles.answerField}>
      <FormikField name={name}>
        {({ field, form }: any): React.ReactElement => {
          const selectProps: { name: string; onChange: (e: any) => void; value?: string } = {
            name: placeholder,
            onChange: (e): void => form.setFieldValue(field.name, e.option.value),
            // explicitly set to undefined in case of null
            value: field.value || undefined,
          };

          return (
            <Select {...selectProps}>
              {!!options &&
                options.map(o => {
                  return (
                    <Option key={o.id} value={o.id} label={o.text}>
                      {o.text}
                    </Option>
                  );
                })}
            </Select>
          );
        }}
      </FormikField>
    </div>
  );
};

const rsvpOptionToValue = ({ value }: any): boolean | null => {
  const map: { [key: string]: boolean | null } = {
    true: true,
    false: false,
    null: null,
  };

  return map[value];
};

export const RsvpDropdown: React.FC<{ name: string }> = ({ name }) => {
  return (
    <div className={styles.answerField}>
      <FormikField name={name}>
        {({ field, form }: any): React.ReactElement => {
          return (
            <Select
              {...field}
              name="Attendance"
              value={String(field.value)}
              onChange={(e: any): void => {
                const value = rsvpOptionToValue(e.option);
                form.setFieldValue(field.name, value);
              }}
            >
              <Option value="null" label="Invited">
                Invited
              </Option>
              <Option value="true" label="Attending">
                Attending
              </Option>
              <Option value="false" label="Declined">
                Declined
              </Option>
            </Select>
          );
        }}
      </FormikField>
    </div>
  );
};
